export default __webpack_public_path__ + "static/media/one_green.7a681f77.svg";